import React from "react";
import {IonButton, IonIcon, IonModal} from "@ionic/react";
import {qrCode} from "ionicons/icons";
import CloseButton from "../utils/buttons/CloseButton";
import Scanner from 'react-webcam-qr-scanner';
import './Scan.css';

/**
 * Component with a button to activate a scanner.
 * @author Alizée Grand
 * @version 1.0
 * @creation 28/03/2022
 * @last_update 28/03/2022
 **/
class Scan extends React.Component<{
    /**
     * Function called when data is read by the scanner.
     * @param {string} data Scanned data.
     * @return {boolean} Returns the outcome of the treatment, true if all went well, false otherwise. Allows to change the visibility of the scanner and to do error management.
     */
    processScannedData: (data: string) => boolean,
    /**
     * Main container id.
     */
    id?: string,
}> {

    state = {
        isScannerVisible: false,
    }

    render() {

        /**
         * Shows or hides the scanner.
         * @param {boolean} visibility True, the scanner is displayed, false it is hidden.
         */
        const changeScannerVisibility = (visibility: boolean) => {
            this.setState({isScannerVisible: visibility});
        }

        /**
         * Function called when the scanner is active.
         * The data processing function passed in props is only called when data is detected and read.
         * @param data Data found by the scanner.
         * @return {Promise<void>}
         */
        const tryScan = async (data: any) => {
            if(data) {
                const result = this.props.processScannedData(data.data.toString());
                if(result) {
                    changeScannerVisibility(false);
                }
            }
        }

        return (
            <div id={this.props.id}>
               <IonButton size="large" expand="block" onClick={() => {changeScannerVisibility(true)}} color="primary">
                    <IonIcon icon={qrCode} slot="start"/>
                    Scanner
               </IonButton>
                <IonModal isOpen={this.state.isScannerVisible} className="modal-scanner">
                    <CloseButton onClickAction={() => {changeScannerVisibility(false)}}/>
                    <Scanner
                        className="qrReader"
                        onDecode={tryScan}
                        constraints={{
                            audio: false,
                            video: {
                                facingMode: "environment"
                            }
                        }}
                        captureSize={{ width: 1280, height: 720 }}
                    />
                </IonModal>
            </div>
        );

    };

}

export default Scan;
